"use client";

import React from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import { updateDescription } from "./constants";
import NewCardText from "../../Atoms/Typography/NewCardText";
import useStore from "../../../lib/Store/useStore";

const HowItWorksIntlCard = ({
    index,
    heading,
    description,
    description2,
    descriptionBold,
    image,
}) => {
    const { currency, price } = useStore();
    return (
        <div className="flex flex-col max-w-[319px] sm:max-w-[458px] items-center rounded-3xl shadow-2xl overflow-hidden">
            <div className=" relative w-[319px] h-[159px] sm:w-[458px] sm:h-[229px] ">
                <Image
                    src={image}
                    alt={heading}
                    fill
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
            </div>
            <div className="p-6">
                <NewCardText
                    text={heading}
                    className="text-left sm:text-center font-[275] font-poppins mb-[18px] text-[30px] sm:text-[32px] leading-[130%] sm:leading-[100%]"
                />
                <NewCardText
                    text={description}
                    className="text-left sm:text-center text-sm mb-[14px] font-poppins font-normal text-[13px] sm:text-lg"
                />
                {description2 && (
                    <NewCardText
                        text={updateDescription(description2, currency, price)}
                        className="text-left sm:text-center mb-[14px] font-poppins font-normal text-[13px] sm:text-lg"
                    />
                )}
                {descriptionBold && (
                    <div className="flex justify-center gap-2">
                        <NewCardText
                            text={descriptionBold?.split("-")?.[0]}
                            className=" text-sm font-medium mb-[14px] sm:text-[17px] font-poppins"
                        />
                        <NewCardText
                            text={descriptionBold?.split("-")?.[1]}
                            className=" text-sm mb-[14px] sm:text-[17px] font-poppins"
                        />
                        <NewCardText
                            text={descriptionBold?.split("-")?.[2]}
                            className=" text-sm font-medium mb-[14px] sm:text-[17px] font-poppins"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default HowItWorksIntlCard;
